import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { usuarioSelector, instalacionSelector, sucursalSelector } from '../../selectors/sessionSelector'
import { calendariosTurneroSelector } from '../../selectors/turneroSelector'
import * as sessionActions from '../../reducers/sessionReducer/actions'
import * as configGlobalActions from '../../reducers/ConfigGlobalReducer/actions'
import * as configuracionesActions from '../../reducers/configuracionesReducer/actions'
import Configuraciones from '../../components/Configuraciones'
import * as Notification from '../../components/Common/notification'
import { getConfigFeedback } from '../../sagas/ConfigGlobalSaga/calls'
import { getMediosDePagoOnlineConfigurables, updateMediosDePagoOnlineEstados } from '../../sagas/pedidosSaga/calls'

const modalidad = {
    Pickup: 1,
    Delivery: 2
}

const configuracionOptions = {
    Precios: 1,
    CobroDelivery: 2,
    DeliveryBonificado: 3,
    TurneroPickupCantDias: 4,
    TurneroPickupTurnos: 5,
    DiasNoLaborablesPickup: 6,
    TurneroDeliveryCantDias: 7,
    TurneroDeliveryTurnos: 8,
    DiasNoLaborablesDelivery: 9,
    SupervisorPicking: 10,
    ModoVidriera: 11,
    FeedbackSmile: 12,
    MediosPagoOnline: 13
}

class ConfiguracionesContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            usuarioCargado: false,
            instalacionCargada: false,
            turneroCargado: false,
            openModal: false,
            showSeccionPrincipal: true,
            calendarioEdit: undefined,

            itemAEditar: undefined,
            esNoLaborable: false,

            nuevoMontoMinimo: undefined,
            errorCompraMinima: undefined,
            errorMontoDeliveryBonificado: undefined,
            infoDiasNoLaborablesPickup: undefined,
            infoDiasNoLaborablesDelivery: undefined,

            checkBoxCobrarEntrega: true,
            checkBoxDeliveryBonificado: true,
            nuevoMontoDelivery: undefined,
            nuevoMontoDeliveryBonificado: undefined,

            nuevaCantDiasHabilitadosPickup: '',
            nuevaCantDiasHabilitadosDelivery: '',
            cantDiasHabilitadosPickup: '',
            cantDiasHabilitadosDelivery: '',
            errores: {},
            
            usuario: this.props.usuario,
            oldPassword: '',
            newPassword: '',
            retypeNewPassword: '',

            tokenFeedbackSmile: '',
            showPassword: false,
            mediosDePagoOnlineConfigurables: [],
            mediosDePagoOnlineTemporal: [],
            showTooltipId: null
        }

        if (this.props.sucursal) {
            this.props.sagaGetCalendariosTurnero({ idInstalacion: this.props.sucursal.idSucursal })
        }
    }

    async componentDidMount() {
        if (typeof getConfigFeedback === 'function') {
            try {
                const tokenFeedbackSmile = await getConfigFeedback()
                this.setState({ tokenFeedbackSmile })
            } catch (error) {
                console.error('Error fetching token:', error)
            }
        }
        try {
            const medios = await getMediosDePagoOnlineConfigurables();
            this.setState({ mediosDePagoOnlineConfigurables: medios });
          } catch (error) {
            console.error('Error cargando medios de pago:', error);
          }
    }

    componentDidUpdate = () => {
        if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
            this.setState({ usuarioCargado: true }, () => {
                if (this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                } 
            })
        }

        if (this.props.sucursal !== undefined && this.state.turneroCargado === false && this.props.calendariosTurnero === undefined) {
            this.setState({
                turneroCargado: true,
            }, () => {
                this.props.sagaGetCalendariosTurnero({ idInstalacion: this.props.sucursal.idSucursal })
            })
        }

        if (this.state.instalacionCargada === false && this.props.instalacion !== undefined ) {
            
            let nuevoMontoMinimo = this.props.instalacion && this.props.instalacion.montoCompraMinimoPermitido !== undefined ? this.props.instalacion.montoCompraMinimoPermitido : undefined
            let checkBoxCobrarEntrega = this.props.instalacion && this.props.instalacion.cobroDelivery !== undefined ? this.props.instalacion.cobroDelivery : true
            let checkBoxDeliveryBonificado = this.props.instalacion && this.props.instalacion.deliveryBonificado !== undefined ? this.props.instalacion.deliveryBonificado : true
            let nuevoMontoDelivery = this.props.instalacion && this.props.instalacion.montoDelivery !== undefined ? this.props.instalacion.montoDelivery : undefined 
            let nuevoMontoDeliveryBonificado = this.props.instalacion && this.props.instalacion.montoDeliveryBonificado !== undefined ? this.props.instalacion.montoDeliveryBonificado : undefined 

            this.setState({
                instalacionCargada: true,
                nuevoMontoMinimo: nuevoMontoMinimo,
                checkBoxCobrarEntrega: checkBoxCobrarEntrega,
                checkBoxDeliveryBonificado: checkBoxDeliveryBonificado,
                nuevoMontoDelivery: nuevoMontoDelivery,
                nuevoMontoDeliveryBonificado: nuevoMontoDeliveryBonificado
            })
        }

    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.instalacion !== this.props.instalacion ) {
            let nuevoMontoMinimo = nextProps.instalacion && nextProps.instalacion.montoCompraMinimoPermitido !== undefined ? nextProps.instalacion.montoCompraMinimoPermitido : undefined
            let checkBoxCobrarEntrega = nextProps.instalacion && nextProps.instalacion.cobroDelivery !== undefined ? nextProps.instalacion.cobroDelivery : true
            let checkBoxDeliveryBonificado = nextProps.instalacion && nextProps.instalacion.deliveryBonificado !== undefined ? nextProps.instalacion.deliveryBonificado : true
            let nuevoMontoDelivery = nextProps.instalacion && nextProps.instalacion.montoDelivery !== undefined ? nextProps.instalacion.montoDelivery : undefined 
            let nuevoMontoDeliveryBonificado = nextProps.instalacion && nextProps.instalacion.montoDeliveryBonificado !== undefined ? nextProps.instalacion.montoDeliveryBonificado : undefined

            this.setState({
                instalacionCargada: true,
                nuevoMontoMinimo: nuevoMontoMinimo,
                checkBoxCobrarEntrega: checkBoxCobrarEntrega,
                checkBoxDeliveryBonificado: checkBoxDeliveryBonificado,
                nuevoMontoDelivery: nuevoMontoDelivery,
                nuevoMontoDeliveryBonificado: nuevoMontoDeliveryBonificado
            })
        }

        if (nextProps.calendariosTurnero !== this.props.calendariosTurnero ) {
            let tipoCalendarioPickup = nextProps.calendariosTurnero && nextProps.calendariosTurnero.length > 0 ? nextProps.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === modalidad.Pickup) : undefined
            let cantDiasHabilitadosPickup = undefined
            let infoDiasNoLaborablesPickup = undefined
            if (tipoCalendarioPickup) {
                cantDiasHabilitadosPickup = tipoCalendarioPickup.diasAdelante
                infoDiasNoLaborablesPickup = tipoCalendarioPickup.infoDiasNoLaborable
            }

            let tipoCalendarioDelivery = nextProps.calendariosTurnero && nextProps.calendariosTurnero.length > 0 ? nextProps.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === modalidad.Delivery) : undefined
            let cantDiasHabilitadosDelivery = undefined
            let infoDiasNoLaborablesDelivery = undefined
            if (tipoCalendarioDelivery) {
                cantDiasHabilitadosDelivery = tipoCalendarioDelivery.diasAdelante
                infoDiasNoLaborablesDelivery = tipoCalendarioDelivery.infoDiasNoLaborable
            }

            this.setState({
                cantDiasHabilitadosPickup: cantDiasHabilitadosPickup,
                cantDiasHabilitadosDelivery: cantDiasHabilitadosDelivery,
                infoDiasNoLaborablesPickup: infoDiasNoLaborablesPickup,
                infoDiasNoLaborablesDelivery: infoDiasNoLaborablesDelivery
            })
        }

        if (nextProps.sucursal !== undefined && this.state.turneroCargado === false && nextProps.calendariosTurnero === undefined) {
            this.setState({
                turneroCargado: true,
            }, () => {
                nextProps.sagaGetCalendariosTurnero({ idInstalacion: nextProps.sucursal.idSucursal })
            })
        }
    }

    handleOnClickEditar = (itemAEditar) => {
        let value = !this.state.openModal

        let showSeccionPrincipal = this.state.showSeccionPrincipal
        let calendarioEdit = this.state.calendarioEdit
        let esNoLaborable = false
        
        if (itemAEditar === configuracionOptions.TurneroPickupTurnos || itemAEditar === configuracionOptions.TurneroDeliveryTurnos) {
            showSeccionPrincipal = false
            let idTipoCalendario = itemAEditar === configuracionOptions.TurneroPickupTurnos ? modalidad.Pickup : modalidad.Delivery
            if (this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0) {
                calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === idTipoCalendario)
            }
            value = false
        }

        if (itemAEditar === configuracionOptions.DiasNoLaborablesPickup || itemAEditar === configuracionOptions.DiasNoLaborablesDelivery) {
            showSeccionPrincipal = false
            let idTipoCalendario = itemAEditar === configuracionOptions.DiasNoLaborablesPickup ? modalidad.Pickup : modalidad.Delivery
            if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === idTipoCalendario)
            }
            value = false
            esNoLaborable = true
        }
        if(itemAEditar === configuracionOptions.MediosPagoOnline){
            this.setState({
                mediosDePagoOnlineTemporal: [...this.state.mediosDePagoOnlineConfigurables]
              });
        }
        
        
        this.setState({
            openModal: value, 
            itemAEditar: itemAEditar, 
            showSeccionPrincipal:showSeccionPrincipal,
            calendarioEdit: calendarioEdit,
            esNoLaborable: esNoLaborable,
            retypeNewPassword: undefined, 
            newPassword: undefined, 
            oldPassword: undefined 
        })
    }

    handleOnChangeMonto = (e, name) => {
        let value = undefined
        if (Number.isNaN(e.floatValue)) {
                value = e.value
            }
            else { 
          value = e.floatValue
        }
        
        this.setState({[name]: value})
    }  

    handleOnClickGuardar = async() => {
        
        let configuracion = this.state.itemAEditar

        switch(configuracion) {
            case configuracionOptions.Precios: {
                if(this.state.nuevoMontoMinimo === undefined || this.state.nuevoMontoMinimo === null || this.state.nuevoMontoMinimo === ""){
                    this.setState({errorCompraMinima: "Ingrese un monto"})
                    return
                }

                let payload = {
                    monto: this.state.nuevoMontoMinimo,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevoMontoMinimo: undefined}, () => {
                    this.props.sagaSetMontoCompraMinima(payload)
                })
                break
            }

            case configuracionOptions.CobroDelivery: {
                if(this.state.nuevoMontoDelivery === undefined || this.state.nuevoMontoDelivery === null || this.state.nuevoMontoDelivery === ""){
                    this.setState({errorCompraMinima: "Ingrese un monto"})
                    return
                }

                let payload = {
                    monto: this.state.nuevoMontoDelivery,
                    cobroDelivery: this.state.checkBoxCobrarEntrega,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevoMontoDelivery: undefined}, () => {
                    this.props.sagaSetConfiguracionDelivery(payload)
                })
                break
            }

            case configuracionOptions.DeliveryBonificado: {
                if(this.state.nuevoMontoDeliveryBonificado === undefined || this.state.nuevoMontoDeliveryBonificado === null || this.state.nuevoMontoDeliveryBonificado === ""){
                    this.setState({errorMontoDeliveryBonificado: "Ingrese un monto"})
                    return
                }

                let payload = {
                    monto: this.state.nuevoMontoDeliveryBonificado,
                    deliveryBonificado: this.state.checkBoxDeliveryBonificado,
                    idInstalacion: this.props.instalacion ? this.props.instalacion.id : undefined,
                }

                this.setState({openModal: false, nuevoMontoDeliveryBonificado: undefined}, () => {
                    this.props.sagaSetConfiguracionDeliveryBonificado(payload)
                })
                break
            }

            case configuracionOptions.TurneroPickupCantDias: {
                if(this.state.nuevaCantDiasHabilitadosPickup === undefined || this.state.nuevaCantDiasHabilitadosPickup === null || this.state.nuevaCantDiasHabilitadosPickup === ""){
                    let errores = {}
                    errores.nuevaCantDiasHabilitadosPickup = "Ingrese una cantidad"
                    this.setState({errores: errores})
                    return
                }

                let payload = {
                    cantidadDias: parseInt(this.state.nuevaCantDiasHabilitadosPickup),
                    modalidad: modalidad.Pickup,
                    idInstalacion: this.props.sucursal ? this.props.sucursal.idSucursal : undefined,
                }

                this.setState({openModal: false, nuevaCantDiasHabilitadosPickup: '', errores: {}, turneroCargado: false}, () => {
                    this.props.sagaSetConfiguracionTurnero(payload)
                })
                break
            }

            case configuracionOptions.TurneroDeliveryCantDias: {
                if(this.state.nuevaCantDiasHabilitadosDelivery === undefined || this.state.nuevaCantDiasHabilitadosDelivery === null || this.state.nuevaCantDiasHabilitadosDelivery === ""){
                    let errores = {}
                    errores.nuevaCantDiasHabilitadosDelivery = "Ingrese una cantidad"
                    this.setState({errores: errores})
                    return
                }

                let payload = {
                    cantidadDias: parseInt(this.state.nuevaCantDiasHabilitadosDelivery),
                    modalidad: modalidad.Delivery,
                    idInstalacion: this.props.sucursal ? this.props.sucursal.idSucursal : undefined,
                }

                this.setState({openModal: false, nuevaCantDiasHabilitadosDelivery: '', errores: {}, turneroCargado: false}, () => {
                    this.props.sagaSetConfiguracionTurnero(payload)
                })
                break
            }

            case configuracionOptions.SupervisorPicking: {
                let inputs = [this.state.oldPassword, this.state.newPassword, this.state.retypeNewPassword];
                
                if(inputs.some((e)=> e.trim().length === 0 )){
                    let errores = {}
                    errores.inputsIncompletos = "Todos los campos son requeridos"
                    this.setState({errores: errores})
                    return
                }

                if(this.state.newPassword !== this.state.retypeNewPassword) {
                    let errores = {}
                    errores.clavesNoCoinciden = "Las claves ingresadas no coinciden"
                    this.setState({errores: errores})
                    return
                }
                           
                let payload = {
                    oldPassword: this.state.oldPassword,
                    newPassword: this.state.newPassword
                }
                this.props.setNewClaveSupervisor(payload)
                this.setState({openModal: false, retypeNewPassword: undefined, newPassword: undefined, oldPassword: undefined })
                break
            }

            case configuracionOptions.FeedbackSmile: {
                if (!this.state.tokenFeedbackSmile || this.state.tokenFeedbackSmile.trim().length === 0) {
                    let errores = {}
                    errores.tokenFeedbackSmile = "El token es requerido"
                    this.setState({ errores: errores })
                    return
                }   

                let payload = {
                    tokenFeedbackSmile: this.state.tokenFeedbackSmile
                }

                this.props.setNewTokenFeedbackSmile(payload)
                this.setState({ openModal: false, tokenFeedbackSmile: undefined })
                break
            }

            case configuracionOptions.MediosPagoOnline: {
                this.setState({ loading: true });
                //Preparar el payload con los datos TEMPORALES (no los originales)
                const payload = this.state.mediosDePagoOnlineTemporal.map((medio) => ({
                    Id: medio.id,
                    Activo: medio.activo,
                }));
            
                try {
                    //Llamar a la API con los cambios temporales
                    await updateMediosDePagoOnlineEstados(payload);
            
                    //Si la API responde OK, actualizar el estado ORIGINAL con los cambios temporales
                    this.setState({
                        mediosDePagoOnlineConfigurables: [...this.state.mediosDePagoOnlineTemporal],
                        openModal: false,
                    });
                } catch (error) {
                    console.error('Error al guardar medios de pago:', error);
                } finally {
                    this.setState({ loading: false });
                }
                break;
            }

            default: break;
        }
    }

    handleOnChange = (e) => {
        let value = e.target.value
        let name = e.target.name
        
        if ((name === 'nuevaCantDiasHabilitadosPickup' || name === 'nuevaCantDiasHabilitadosDelivery') && value !== "") {
            var letterNumber = /^[0-9]+$/;
            if (value.length > 9 || !value.match(letterNumber)) {
              return
            }
        }

        if (name === "checkBoxCobrarEntrega" || name === "checkBoxDeliveryBonificado") {
            value = e.target.checked
        }

        this.setState({[name]: value})      
        
    }

    handleSwitchChangeMedioPago = (idMedioPago, nuevoEstado) => {
        this.setState(prevState => {
          // Copia del estado temporal actual
          const nuevosMedios = [...prevState.mediosDePagoOnlineTemporal];
          
          // Encuentra el medio que se está modificando
          const medioIndex = nuevosMedios.findIndex(m => m.id === idMedioPago);
          const medioActual = nuevosMedios[medioIndex];
      
          // Si intenta DESACTIVAR un medio, verifica que no sea el último activo
          if (!nuevoEstado) {
            const mediosActivos = nuevosMedios.filter(m => m.activo).length;
            const esUltimoActivo = medioActual.activo && mediosActivos <= 1;
      
            if (esUltimoActivo) {
              
                return { 
                    ...prevState,
                    showTooltipId: idMedioPago,
                    mediosDePagoOnlineTemporal: prevState.mediosDePagoOnlineTemporal 
                  };
            }
          }
      
          // Actualiza el estado si pasa la validación
          return {
            showTooltipId: null,
            mediosDePagoOnlineTemporal: nuevosMedios.map(medio =>
              medio.id === idMedioPago ? { ...medio, activo: nuevoEstado } : medio
            )
          };
        });
      };

    handleOnChangeInput = (e) => {
        let value = e.target.value
        let name = e.target.name
        
        this.setState({[name]: value})
    }

    handleOnBack = () => {
        this.setState({
            showSeccionPrincipal: true,
            esNoLaborable: false
        })
    }

    handleOnEliminarCalendarioHorario = (idCalendarioHorario) => {

        if (idCalendarioHorario === undefined || idCalendarioHorario === null) {
            return
        }

        let payload = {}
        payload.idCalendarioHorario = idCalendarioHorario
        payload.idTipoCalendario = this.state.calendarioEdit ? this.state.calendarioEdit.idTipoCalendarioCodigoExterno : undefined
        payload.idInstalacion = this.props.sucursal ? this.props.sucursal.idSucursal : undefined

        payload.callback = () => {
            Notification.showSuccess("Horario eliminado con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if (itemAEditar === configuracionOptions.TurneroPickupTurnos || itemAEditar === configuracionOptions.TurneroDeliveryTurnos) {
                let idTipoCalendario = itemAEditar === configuracionOptions.TurneroPickupTurnos ? modalidad.Pickup : modalidad.Delivery
                if (this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0) {
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === idTipoCalendario)
                }
            }

            this.setState({ calendarioEdit: calendarioEdit })
        } 

        this.setState({ turneroCargado: false }, () => {
            this.props.sagaEliminarCalendarioHorario(payload)
        })
    }

    handleOnEliminarCalendarioNoLaborable = (idCalendarioNoLaborable) => {
        if (idCalendarioNoLaborable === undefined || idCalendarioNoLaborable === null) {
            return
        }

        let payload = {}
        payload.idCalendarioNoLaborable = idCalendarioNoLaborable
        payload.idInstalacion = this.props.sucursal ? this.props.sucursal.idSucursal : undefined

        payload.callback = () => {
            Notification.showSuccess("Fecha eliminada con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if (itemAEditar === configuracionOptions.DiasNoLaborablesPickup || itemAEditar === configuracionOptions.DiasNoLaborablesDelivery) {
                let idTipoCalendario = itemAEditar === configuracionOptions.DiasNoLaborablesPickup ? modalidad.Pickup : modalidad.Delivery
                if (this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0) {
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === idTipoCalendario)
                }
            }

            this.setState({ calendarioEdit: calendarioEdit })
        } 

        this.setState({ turneroCargado: false }, () => {
            this.props.sagaEliminarCalendarioNoLaborable(payload)
        })
    }

    handleOnSaveTurno = (p) => {
        let payload = p
        payload.idInstalacion = this.props.sucursal ? this.props.sucursal.idSucursal : undefined

        payload.callback = () => {
            Notification.showSuccess("Horario guardado con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if(itemAEditar === configuracionOptions.TurneroPickupTurnos || itemAEditar === configuracionOptions.TurneroDeliveryTurnos){
                let idTipoCalendario = itemAEditar === configuracionOptions.TurneroPickupTurnos ? modalidad.Pickup : modalidad.Delivery
                if(this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0){
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === idTipoCalendario)
                }
            }

            this.setState({ calendarioEdit: calendarioEdit })
        } 

        this.props.sagaSaveCalendarioHorario(payload)
    }

    handleOnSaveCalendarioNoLaborable = (p) => {
        let payload = p
        payload.idInstalacion = this.props.sucursal ? this.props.sucursal.idSucursal : undefined
        payload.idTipoCalendario = this.state.calendarioEdit ? this.state.calendarioEdit.idTipoCalendario : undefined
        payload.idRecurso = 1 // INDICA RECURSO DE SUCURSAL RECOLE !"HARDCODEADO"

        payload.callback = () => {
            Notification.showSuccess("Día guardado con éxito")
            
            let calendarioEdit = this.state.calendarioEdit
            let itemAEditar = this.state.itemAEditar

            if (itemAEditar === configuracionOptions.DiasNoLaborablesPickup || itemAEditar === configuracionOptions.DiasNoLaborablesDelivery) {
                let idTipoCalendario = itemAEditar === configuracionOptions.DiasNoLaborablesPickup ? modalidad.Pickup : modalidad.Delivery
                if (this.props.calendariosTurnero && this.props.calendariosTurnero.length > 0) {
                    calendarioEdit = this.props.calendariosTurnero.find(x => x.idTipoCalendarioCodigoExterno === idTipoCalendario)
                }
            }

            this.setState({ calendarioEdit: calendarioEdit })
        } 

        this.props.sagaSaveCalendarioNoLaborable(payload)
    }

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword })
    }

    handleOnChangeTokenFeedbackSmile = (e) => {
        this.setState({ tokenFeedbackSmile: e.target.value })
    }

    render() {
        return (
            <Configuraciones 
                itemAEditar={this.state.itemAEditar}
                errorCompraMinima={this.state.errorCompraMinima}
                errorMontoDeliveryBonificado={this.state.errorMontoDeliveryBonificado}
                openModal={this.state.openModal}
                showSeccionPrincipal={this.state.showSeccionPrincipal}
                nuevoMontoMinimo={this.state.nuevoMontoMinimo}
                nuevoMontoDelivery={this.state.nuevoMontoDelivery}
                nuevoMontoDeliveryBonificado={this.state.nuevoMontoDeliveryBonificado}
                infoDiasNoLaborablesPickup={this.state.infoDiasNoLaborablesPickup}
                infoDiasNoLaborablesDelivery={this.state.infoDiasNoLaborablesDelivery}
                checkBoxCobrarEntrega={this.state.checkBoxCobrarEntrega}
                checkBoxDeliveryBonificado={this.state.checkBoxDeliveryBonificado}
                nuevaCantDiasHabilitadosPickup={this.state.nuevaCantDiasHabilitadosPickup}
                nuevaCantDiasHabilitadosDelivery={this.state.nuevaCantDiasHabilitadosDelivery}
                cantDiasHabilitadosPickup={this.state.cantDiasHabilitadosPickup}
                cantDiasHabilitadosDelivery={this.state.cantDiasHabilitadosDelivery}
                calendarioEdit={this.state.calendarioEdit}
                esNoLaborable={this.state.esNoLaborable}
                errores={this.state.errores}
                handleOnClickEditar={this.handleOnClickEditar}
                handleOnChangeMonto={this.handleOnChangeMonto}
                handleOnClickGuardar={this.handleOnClickGuardar}
                handleOnChange={this.handleOnChange}
                handleOnBack={this.handleOnBack}
                handleOnSaveTurno={this.handleOnSaveTurno}
                handleOnEliminarCalendarioHorario={this.handleOnEliminarCalendarioHorario}
                handleOnEliminarCalendarioNoLaborable={this.handleOnEliminarCalendarioNoLaborable}
                handleOnSaveCalendarioNoLaborable={this.handleOnSaveCalendarioNoLaborable}
                montoCompraMinimo={this.props.instalacion ? this.props.instalacion.montoCompraMinimoPermitido : undefined}
                cobroDelivery={this.props.instalacion ? this.props.instalacion.cobroDelivery : undefined}
                montoDelivery={this.props.instalacion ? this.props.instalacion.montoDelivery : false}
                deliveryBonificado={this.props.instalacion ? this.props.instalacion.deliveryBonificado : undefined}
                montoDeliveryBonificado={this.props.instalacion ? this.props.instalacion.montoDeliveryBonificado : false}
                usuario={this.props.usuario}
                supervisorPicking={this.props.supervisorPicking}
                handleOnChangeInput={this.handleOnChangeInput}
                oldPassword={this.state.oldPassword}
                newPassword={this.state.newPassword}
                retypeNewPassword={this.state.retypeNewPassword}
                tokenFeedbackSmile={this.state.tokenFeedbackSmile}
                toggleShowPassword={this.toggleShowPassword}
                showPassword={this.state.showPassword}
                handleOnChangeTokenFeedbackSmile={this.handleOnChangeTokenFeedbackSmile}
                sucursal={this.props.sucursal}
                mediosDePagoOnlineTemporal={this.state.mediosDePagoOnlineTemporal}
                handleSwitchChangeMedioPago={this.handleSwitchChangeMedioPago}
                showTooltipId={this.state.showTooltipId}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...sessionActions,
        ...configGlobalActions,
        ...configuracionesActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
        instalacion: instalacionSelector(state),
        calendariosTurnero: calendariosTurneroSelector(state),
        sucursal: sucursalSelector(state)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracionesContainer)